'use strict';

/**
 * @classname PurchaseRouteType
 * @classdesc 購入経路
 */
export default class PurchaseRouteType {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-order-confirm
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		const $route = $('#purchase_route_type');
		if(	$('html').hasClass('iphone') ||
			$('html').hasClass('android') ||
			$('html').hasClass('ipad') ||
			$('html').hasClass('windows_phone')){
			$route.val('mobile');
		}else{
			$route.val('pc');
		}
	};
};
